import { render } from "./SocialValueBox.vue?vue&type=template&id=62c04006"
import script from "./SocialValueBox.vue?vue&type=script&lang=js"
export * from "./SocialValueBox.vue?vue&type=script&lang=js"

import "./SocialValueBox.vue?vue&type=style&index=0&id=62c04006&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__